import React, { forwardRef, useCallback, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

interface HtmlViewerContentProps {
  content: string;
}

export const HtmlViewerContent = forwardRef<
  HTMLDivElement,
  HtmlViewerContentProps
>(({ content }, ref) => {
  const innerRef = useRef<HTMLDivElement | null>(null);

  const setRefs = useCallback(
    (node: HTMLDivElement | null) => {
      innerRef.current = node;
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );

  useEffect(() => {
    const root = innerRef.current;
    if (!root) return;

    const disableNativeDrag = () => {
      root.querySelectorAll('img, a').forEach(el => {
        el.setAttribute('draggable', 'false');
      });
    };

    disableNativeDrag();
  }, [content]);

  if (!content) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          color: 'text.disabled',
        }}
      >
        <Typography variant="body2">표시할 콘텐츠가 없습니다.</Typography>
      </Box>
    );
  }

  return (
    <Box
      ref={setRefs}
      sx={{
        position: 'relative',
        wordBreak: 'break-word',
        lineHeight: 1.75,
        '& img': { maxWidth: '100%', WebkitUserDrag: 'none' },
        '& a': { color: 'primary.main' },
      }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
});

HtmlViewerContent.displayName = 'HtmlViewerContent';
